// src/api/titles.js

import api from "./axios";

// AS-IS (수정 전)
// export const getMyTitles = () => api.get("/api/rewards/titles/mine/");

// TO-BE (✅ 이걸로 교체해주세요!)
export const getMyTitles = async () => {
    try {
        // 1. API를 호출하고 응답 데이터를 받습니다.
        const { data } = await api.get("/api/rewards/titles/mine/");

        // 2. 응답 데이터에서 실제 칭호 배열('titles' 키)을 추출합니다.
        const titlesList = data?.titles || [];

        // 3. 추출된 순수 배열을 반환합니다.
        return Array.isArray(titlesList) ? titlesList : [];

    } catch (e) {
        // 4. 에러 발생 시 콘솔에 경고를 남기고 빈 배열을 반환합니다.
        console.warn("getMyTitles API 호출 또는 파싱 실패", e);
        return [];
    }
};

export const getUserTitles = async (username) => {
    const safe = encodeURIComponent(username);
    const { data } = await api.get(`/api/rewards/titles/user/by-username/${safe}/`);
    return data || [];
};